import ReactComponent from "../app/ReactComponent";
import {Layout, Row, Col, Image, Space, Alert, Spin} from 'antd'

import {RewardItem} from '../components/layout/RewardItem'
import React from 'react'
import Query from "../app/Query";
import CoinSVG from "../image/coin.svg";
import {Link} from "react-router-dom";
import AdditionsSVG from "../image/pripisy.svg"
import MyOrdersSVG from "../image/moje_objednavky.svg"
import {prettyNumber} from '../helpers/utils'
import {getLoyaltyStatus} from '../services/properties'
import {LoyaltyStatusTag} from '../components/loyalty-status/LoyaltyStatusTag'
import {LoyaltyProgressBar} from '../components/loyalty-status/LoyaltyProgressBar'
import {getBloodSamplesEvents} from '../services/events'

export class RewardsPage extends ReactComponent {
  state = {
    loading_page: true,
    available_points: 0,
    loyalty_status: null,
    donations_count: 0,
    rewards: [],
    overview: {
      items: [],
      sorter: {
        sort_field: 'points_cost',
        sort_direction: 'asc',
        sort_fields: [
          'points_cost',
          'name'
        ]
      },
      pagination: {
        page_length: 100,
        current_page: 1,
        total_items: 1,
        current_offset: 0
      }
    }
  }

  componentDidMount() {

    this.scrollToTop()
    this.pushPageAnalytics("Odměny - Moje Amber")

    void this.getPageData()

  }

  getPageData = async () => {
    void this.updateState({
      loading_page: true
    })

    const points = await this.$app.$store('account').getPoints()

    void this.updateState({
      available_points: points
    })


    const loyalty_status = await getLoyaltyStatus(await this.$app.$store('account').getProperties())

    void this.updateState({
      loyalty_status
    })

    const {total_items: donations_count = 0} = await getBloodSamplesEvents(0, 1)

    void this.updateState({
      donations_count
    })

    await this.getRewards()

    void this.updateState({
      loading_page: false
    })

  }

  async getRewards(offset = this.state.overview.pagination.current_offset, sort_field = this.state.overview.sorter.sort_field, sort_direction = this.state.overview.sorter.sort_direction) {
    const query = new Query('rewards')

    query.add('count', this.state.overview.pagination.page_length)
    query.add('offset', offset)
    query.add('sort_field', sort_field)
    query.add('sort_direction', sort_direction)
    query.add('is_valid', true)
    query.add('reward_group', 1)

    const {rewards = []} = await this.$api({
      action: 'carecloud_user_api',
      route: query.route
    })

    void this.updateState({
      rewards: rewards
    })

  }

  render() {
    return (
      <Layout tagName={"main"} className="male rewards">
        <Row align="center">
          <Col xs={24}>
            <Row align="center">
              <Col xs={24} md={24} lg={14} xl={13} className="rewards-left">
                <Row className="rewards-header">
                  <Space direction="vertical" className="rewards-content">
                    <Col>
                      <Row className="rewards-title-row">
                        <Col xs={12} className="rewards-title-col">
                          <Space direction="vertical" className="rewards-title">
                            <h1>Amber Klub</h1>
                            <LoyaltyStatusTag status={this.state.loyalty_status}/>
                          </Space>
                        </Col>
                        <Col xs={12} className="rewards-balance-col">
                          <Space direction="horizontal" align="center" size={[27, 20]} className="rewards-balance" wrap>
                            <div className="blue-circle mobile">
                              <p>Stav konta</p>
                              <h2>{prettyNumber(this.state.available_points)} <img alt="Amberka" width={20} height={20} src={CoinSVG}/></h2>
                              <p>{this.$app.$tc('common', 'points', this.state.available_points)}</p>
                            </div>
                          </Space>
                        </Col>
                      </Row>
                    </Col>
                    <Col className="loyalty-progress-bar-col">
                      <LoyaltyProgressBar donationsCount={this.state.donations_count}/>
                    </Col>
                    <Col xs={0} md={0} lg={24}>
                      <Space direction="horizontal" align="center" size={[0, 42]} className="rewards-links" wrap>
                        <Link to={"/rewards-history"}>
                          <div className="order mobile">
                            <Image preview={false} src={MyOrdersSVG}></Image>
                            <p>Moje objednávky</p>
                          </div>
                        </Link>
                        <Link to={"/points-history"}>
                          <div className="order mobile">
                            <Image preview={false} src={AdditionsSVG}></Image>
                            <p>Moje přípisy</p>
                          </div>
                        </Link>
                      </Space>
                    </Col>
                  </Space>
                </Row>
              </Col>
              <Col xs={24} md={24} lg={10} xl={11}>
                <h4 className="mb-1">Dárky</h4>
                <Spin spinning={this.state.loading_page} size="large" />
                <Space size={[24, 15]} className="rewards-item-container" wrap>
                  {!this.state.loading_page && this.state.rewards.length === 0 &&
                    <Alert
                      message="Žádné odměny k dispozici."
                      type="info"
                      banner={true}
                      showIcon
                    />}
                  {this.state.rewards.length !== 0 &&
                    this.state.rewards.map(item => (
                      <RewardItem key={item.reward_id} reward={item} available_points={this.state.available_points} reloadRewardsPageData={this.getPageData}/>
                    ))
                  }
                </Space>
              </Col>
              <Col xs={24} md={24} lg={0}>
                <Space direction="horizontal" align="center" size={[30, 30]} className="mobile-links mt-4 mb-3" wrap>
                  <Link to={"/rewards-history"}>
                    <div className="order mobile">
                      <Image preview={false} src={MyOrdersSVG}></Image>
                      <p>Moje objednávky</p>
                    </div>
                  </Link>
                  <Link to={"/points-history"}>
                    <div className="order mobile">
                      <Image preview={false} src={AdditionsSVG}></Image>
                      <p>Moje přípisy</p>
                    </div>
                  </Link>
                </Space>
              </Col>
            </Row>
          </Col>
        </Row>
      </Layout>
    )
  }
}